import { CheckoutDirectDebitMethod } from '@checkout';
import { RequestAction, RequestSource, TrustBox } from '@common';
import { BuildConfig, DomainId } from '@config';

export const buildConfig: BuildConfig = {
  applianceRegistrationLimit: 10,
  appVariantConfigPath: 'gb/sidedoor-tv',
  buildFeatures: {},
  checkout: {
    directDebit: {
      method: CheckoutDirectDebitMethod.AccountNumberSortCode,
    },
  },
  defaultDomainId: DomainId.LG,
  domainIdMapping: {
    [DomainId.LG]: /lg\.[\w.-]*partners/,
  },
  emailMandatory: false,
  modelNumberSearchEnabledBrands: [],
  modelNumberSelectionRequiredBrands: [],
  serialNumberSelectionRequiredBrands: [],
  partnerLogoImagePath: 'powered-by-dng.svg',
  retailerFieldEnabledBrands: [],
  trustpilot: {
    businessUnitId: '4cb3113600006400050dfb02',
    templates: [
      { id: '5419b6ffb0d04a076446a9af', name: TrustBox.Micro },
      { id: '54ad5defc6454f065c28af8b', name: TrustBox.Slider },
    ],
  },
  requestAction: RequestAction.OnlineRegistration,
  whiteLabelClient: RequestSource.DomesticAndGeneralUK,
};
